import React from "react";
import { LINKS, BRAND, PRICE_SECTION_LINK } from "@/lib/content";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#c5a059]/15 py-10 mt-4"
      style={{ background: "#0c1a26" }}
    >
      <div className="et-container">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <span
              className="grid place-items-center w-9 h-9 rounded-full text-[#10202e] font-bold text-sm tracking-tight"
              style={{
                background:
                  "linear-gradient(135deg, #c5a059 0%, #e3c98c 50%, #c5a059 100%)",
              }}
            >
              ET
            </span>
            <div>
              <p className="text-sm text-[#f5f2ea] font-semibold leading-tight">
                {BRAND.name}
              </p>
              <p className="text-xs text-[#f5f2ea]/55 mt-0.5">
                {BRAND.tagline}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[#f5f2ea]/70">
            <a
              href={LINKS.home}
              data-testid="footer-home"
              className="hover:text-[#c5a059] transition-colors"
            >
              Web
            </a>
            <a
              href={LINKS.about}
              data-testid="footer-about"
              className="hover:text-[#c5a059] transition-colors"
            >
              Sobre mí
            </a>
            <a
              href={LINKS.method}
              data-testid="footer-method"
              className="hover:text-[#c5a059] transition-colors"
            >
              Método
            </a>
            <a
              href={LINKS.blog}
              data-testid="footer-blog"
              className="hover:text-[#c5a059] transition-colors"
            >
              Blog
            </a>
            <a
              href={LINKS.radio}
              data-testid="footer-radio"
              className="hover:text-[#c5a059] transition-colors"
            >
              Radio
            </a>
            <a
              href={LINKS.lab}
              data-testid="footer-lab"
              className="hover:text-[#c5a059] transition-colors"
            >
              Laboratorio IA
            </a>
            <a
              href={PRICE_SECTION_LINK}
              data-testid="footer-cta"
              className="hover:text-[#c5a059] transition-colors"
            >
              Radiografía
            </a>
          </div>
        </div>

        <div className="et-gold-line mt-8" />

        <p className="mt-6 text-xs text-[#f5f2ea]/40 text-center md:text-left">
          © {new Date().getFullYear()} Enrique Torres. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
